/**
 * Created by Adam Harder on 12/18/2017.
 */

export class cms_logging {
    public static error(message: string): void {
        console.error(`${message}`);
    }

    public static log(message: string): void {
        console.log(message);
    }

    /**
     * api_call_error() is used to capture errors thrown by the API gateway. This should be logged as a serious, irrecoverable error.
     * @param endpoint_url the endpoint that responded with an error
     * @param xhr value from Jquery AJAX.
     * @param textStatus value from Jquery AJAX
     * @param errorThrown value from Jquery AJAX.
     */

    public static api_call_error(endpoint_url:string, xhr:any, textStatus:any, errorThrown:any): void {
        console.error(`API ${endpoint_url} ERROR ${errorThrown}`);
    }

    /**
     * api_error() is used to capture missing or malformed data arriving from the database. this should be logged as an error
     * @param message a message to print out
     * @param id an ID to help find this item in the database. Probabaly a UUID.
     * @param endpoint the endpoint that produced this data
     * @param raw_data the raw API output.
     */
    public static api_error(message: string, id: string, endpoint?: string, raw_data?: any): void {
        if (!endpoint) {
            endpoint = "";
        }
        console.error(`API ${endpoint} ERROR ${message}`);
        if (raw_data) {
            cms_logging.log(`${JSON.stringify(raw_data, null, " ")}`);
        }
    }

    public static printf_info(message: string): void {
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
            console.info(`debug print ${message}`)
        }
    }
    public static printf(message: string, stacktrace?: boolean): void {
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
            cms_logging.log(`debug print ${message}`)
            if (stacktrace === null) {
                stacktrace = true;
            }
            if (stacktrace === undefined) {
                stacktrace = true;
            }
            if (stacktrace) {
                console.trace();
            }
        }
    }


}



// WEBPACK FOOTER //
// ./src/ts/cms_logging.ts